module.exports = __webpack_public_path__ + "img/keyboard-arrow-next.875f003d.svg";